<template>
  <b-modal
    :visible="shown"
    size="lg"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @hide="handleClose"
    hide-footer>
    <div slot="modal-title">
      <h4 class="m-0">Data Upload</h4>
      <div class="title-description">
        <!-- Bring data into SuperScore from almost any source by uploading CSV files -->
        Upload a new CSV file <span v-if="meta != null">as your <strong style="color: #0df">{{ meta.name }}</strong></span>
      </div>
    </div>

    <div class="mx-3">
      <div>
        <upload-or-library
            v-if="meta != null"
            :file-type="meta.type"
            :project="project"
            @fail="handleFail"
            @success="handleSuccess" />
        <!-- <step
          v-if="step === 1"
          position="1"
          title="File source"
          description="Upload a new CSV file or pick one from previously uploaded files">
          
          <upload-or-library
            :file-type="meta.type"
            :project="project"
            @success="step = 2" />
          
        </step>
        <step
          v-else-if="step === 2"
          position="2"
          title="File type mapping"
          description="Help us know how you want to use this file">
          <file-type-map
            :meta="meta"
            :support-next="true"
            @success="step = 3" />
        </step>
        <step
          v-else-if="step === 3"
          position="2"
          title="Known entity mapping"
          description="Help us understand your data structure">
          <column-map
            :meta="meta"
            :support-next="true"
            @success="step = 4" />
        </step>
        <step
          v-else-if="step === 4"
          position="2"
          title="Data type mapping"
          description="Help us understand your data structure">
          <data-type-map
            :meta="meta"
            :support-next="true"
            @success="handleClose" />
        </step> -->
      </div>
    </div>
  </b-modal>
</template>

<script>
  import UploadOrLibrary from './UploadOrLibrary';
  import FileTypeMap from './FileTypeMap';
  import ColumnMap from './ColumnMap';
  import DataTypeMap from './DataTypeMap';
  import Step from './Step';

  export default {
    name: 'DataUploadModal',
    components: {Step, UploadOrLibrary, FileTypeMap, ColumnMap, DataTypeMap},
    props: {
      shown: Boolean,
      project: Object,
      meta: Object
      // file: String
    },

    data() {
      return {
        step: 1
      };
    },

    methods: {
      handleSuccess(value, event) {
        value['meta'] = this.meta;
        value['project'] = this.project;
        this.$emit('success', value);
        this.$emit('close');
      },
      
      handleFail(value, event) {
        value['meta'] = this.meta;
        value['project'] = this.project;
        this.$emit('fail', value);
        this.$emit('close');
      },
      
      handleClose() {
        this.$emit('close');
      }
    }
  };
</script>

<style scoped>
  .title-description {
    font-weight: normal;
    font-size: .8em;
  }
</style>
